import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceActionCustomParameterByValue',
  standalone: false,
})
export class ReplaceActionCustomParameterByValuePipe implements PipeTransform {
  transform(
    str: string,
    idProperty: string,
    valueToReplace: string | number,
  ): string {
    if (!str || !idProperty || valueToReplace == null) return '';

    return str.replace('@' + idProperty, String(valueToReplace));
  }
}
